import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { OnAppInit, ProductBootstrapper, SessionStoreService, UserEvent, UserLogoutEvent, UserService } from '@frontend/vanilla/core';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { CommonClientConfig } from './client-config/client-config.models';
import { ScrollToService } from './services/scrollTo.service';
import { TagManagerRendererService } from './services/tagmanager-renderer.service';
import { Unicodeservice } from './unicode.service';

@Injectable({ providedIn: 'root' })
export class PortalProductBootstrapper implements ProductBootstrapper, OnAppInit {
    private deactivate = new Subject<void>();
    portalComposition: string[] = [];
    constructor(
        private tagManagerRenderer: TagManagerRendererService,
        private commonClientConfigService: CommonClientConfig,
        private unicodeservice: Unicodeservice,
        private router: Router,
        private user: UserService,
        private scrollService: ScrollToService,
        private sessionStore: SessionStoreService,
    ) {}

    onLoad() {}

    onAppInit() {
        /*initialise only once based on flag*/
        if (this.portalComposition.length) return;
        this.portalComposition = this.commonClientConfigService.unicodeComponentSelector;
        if (this.portalComposition && this.portalComposition.length > 0) this.inputChangeEventListener();
        this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
            if (this.user.workflowType != 0) {
                this.scrollService.scrollTo('html', 500, 0);
            }
        });
        this.user.events.pipe(filter((e: UserEvent) => e instanceof UserLogoutEvent)).subscribe(() => {
            this.sessionStore.remove('isOrganicReg');
        });
    }

    onActivate() {}

    onDeactivate(): void | Promise<void> {
        this.deactivate.next();
        this.deactivate.complete();
    }

    inputChangeEventListener() {
        const ranges: string[] = [];
        ranges.push(this.commonClientConfigService.unicodeRegex);
        const regex = new RegExp(ranges.join('|'), 'g');
        document.addEventListener('input', (e: any) => {
            if (
                this.portalComposition &&
                this.portalComposition.length > 0 &&
                this.portalComposition.some((el) => document.getElementsByTagName(el).length > 0)
            ) {
                const tagName = e.target.nodeName.toLowerCase();
                if (tagName == 'input' && e.target.type == 'email') {
                    e.target.value = this.tagManagerRenderer.validateEmailFieldByRegex(e.target.value, ranges);
                    this.unicodeservice.updateformfield(e);
                } else if (((tagName == 'input' && e.target.type == 'text') || tagName == 'textarea') && e.target.type != 'file') {
                    let str: string = e.target.value;
                    if (str && regex.test(str)) {
                        str = str.replace(regex, '');
                    }
                    e.target.value = str.trimLeft();
                    this.unicodeservice.updateformfield(e);
                }
            }
        });
    }
}
